import ApiClient from './ApiClient'

export default class SecurityUrlClient extends ApiClient {
    postSecurityUrl = (url) => this.post('/security_url', { url })

    getAll = (page = 1) => this.get('/security_url', { page })

    deleteSecurityUrl = (security_url_id) => this.delete(`/security_url/${security_url_id}`)

}
